import { array, bool, number, object, string } from "yup";
import { dateMax, dateSameOrAfter, stringMax } from "./utils";

export const getTransactionChildValidationSchema = (balanceTypes) => {
  return object({
    comment: stringMax(250).required(" "),
    balances: array()
      .of(
        object({
          montant: number().required(" "),
          affectation: stringMax(250).required(" "),
        }),
      )
      .optional(),
    montant: number().required(" "),
    id_bien: number().optional(),
    id_tenant: number().optional(),
    id_property_folder: number().optional(),
    id_profile_bailleur: number().optional(),
    // La cible est exigée par son domaine, pas par `affectation` : les lignes venant
    // d'un modèle de découpe portent `domaine` (FinanceSplit) et non `affectation`.
    domaine: stringMax(250).required(" "),
    parent: stringMax(250).optional(),
    type: stringMax(250).required(" "),
    periode_debut: dateMax().when("type", {
      is: (type) => {
        const selectedType = balanceTypes?.[type];
        return selectedType?.has_period === true;
      },
      then: (schema) =>
        schema.required("La date de début de période est obligatoire"),
      otherwise: (schema) => schema.optional(" "),
    }),
    periode_fin: dateSameOrAfter(
      "periode_debut",
      "La fin de période ne peut pas être antérieure au début",
    ).when("type", {
      is: (type) => {
        const selectedType = balanceTypes?.[type];
        return selectedType?.has_period === true;
      },
      then: (schema) =>
        schema.required("La date de fin de période est obligatoire"),
      // Masqués, les champs de période gardent leur valeur : l'ordre des dates ne doit
      // pas bloquer le formulaire sur une erreur que l'utilisateur ne voit pas.
      otherwise: () => dateMax().optional(" "),
    }),
    refacturation_values: array()
      .of(
        object({
          tenant_id: string().required(" "),
          date: dateMax().required(" "),
        }),
      )
      .optional(),
  });
};

// Schéma par défaut pour compatibilité (sans vérification has_period)
export const transactionChildValidationSchema = object({
  comment: stringMax(250).required(" "),
  balances: array()
    .of(
      object({
        montant: number().required(" "),
        affectation: stringMax(250).required(" "),
      }),
    )
    .optional(),
  montant: number().required(" "),
  id_bien: number().optional(),
  id_tenant: number().optional(),
  id_property_folder: number().optional(),
  id_profile_bailleur: number().optional(),
  domaine: stringMax(250).required(" "),
  parent: stringMax(250).optional(),
  type: stringMax(250).required(" "),
  periode_debut: dateMax().optional(" "),
  periode_fin: dateMax().optional(" "),
  refacture_tenant_id: string().optional(),
  refacture_date: dateMax().optional(),
});

export const getTransactionSplitValidationSchema = (balanceTypes) => {
  return object({
    balances: array().of(getTransactionChildValidationSchema(balanceTypes)),
    template: number().integer().optional(),
    update_template: bool(),
    save_keyword: bool(),
  });
};

// Schéma par défaut pour compatibilité
export const transactionSplitValidationSchema = object({
  balances: array().of(transactionChildValidationSchema),
  template: number().integer().optional(),
  update_template: bool(),
  save_keyword: bool(),
});

export const TRANSACTION_CHILD_INITIAL_VALUE = {
  comment: "",
  montant: "",
  id_bien: "",
  id_tenant: "",
  id_property_folder: "",
  id_profile_bailleur: "",
  domaine: "",
  parent: "",
  type: "",
  periode_debut: "",
  periode_fin: "",
  refacturation_values: [],
};

export const TRANSACTION_SPLIT_FORM_INITIAL_VALUE = {
  balances: [TRANSACTION_CHILD_INITIAL_VALUE],
  template: "",
  update_template: false,
  save_keyword: false,
  files: [],
};
